
import React from 'react';
import { RefreshCw, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface RefreshDataButtonProps {
  onRefresh: () => void;
  isLoading: boolean;
}

const RefreshDataButton = ({ onRefresh, isLoading }: RefreshDataButtonProps) => {
  return (
    <Button 
      variant="outline" 
      size="sm"
      onClick={onRefresh}
      disabled={isLoading}
      className="flex items-center gap-2"
    >
      {isLoading ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : (
        <RefreshCw className="h-4 w-4" />
      )}
      Refresh Data
    </Button>
  );
};

export default RefreshDataButton;
